export default __webpack_public_path__ + "static/media/vip.cdf944e3.png";